/** @format */

import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { RootState } from "../../app/store";

export type themeTypes =
  | "alevel"
  | "gcse"
  | "other"
  | "vq"
  | "asbwales"
  | "qdo"
  | "vqEntryPath"
  | "mfwGcse"
  | "mfwAlevel"
  | "mfwLevel2"
  | "multiLevel"
  | "vqLevel12"
  | "vqLevel23"
  | "vqLevel3";

type themeState = {
  theme: themeTypes;
  status: "idle" | "loading" | "failed";
};
const initialState: themeState = {
  theme: "gcse",
  status: "idle",
};

export const themeSlice = createSlice({
  name: "theme",
  initialState,
  reducers: {
    setTheme: (state, action: PayloadAction<themeTypes>) => {
      state.theme = action.payload;
      document.documentElement.setAttribute("data-bs-theme", action.payload);
    },
  },
});

export const { setTheme } = themeSlice.actions;
export const selectTheme = () => (state: RootState) => state.theme.theme;
export default themeSlice.reducer;
